import { ExpressionParser } from "./expression-parser";
import { Finder } from "./finder";

export class RuleEngine {

    constructor(rules) {
        this.rulesData = rules.rulesData || [];
        this.actionsAdapter = rules.actionsAdapter;
    }

    runAll(conditionsAdapter, cb) {
        var self = this;
        $.each(self.rulesData, function (r, rule) {
            self.run(r, conditionsAdapter, cb);
        });
    }

    run(ruleIndex, conditionsAdapter, cb) {
        var self = this;
        var rule = self.rulesData[ruleIndex];
        if (typeof rule !== "undefined" && rule !== "" && rule.attributactives !== "off") {
            self.ifActions = rule.ifActions || [];
            self.elseActions = rule.elseActions || [];
            self.conditions = rule.conditions || { all: [] };
            var out, error;
            self.matches(conditionsAdapter, function (err, result) {
                out = result;
                error = err;
                if (!err) {
                    if (result) {
                        self.runIfActions(self.actionsAdapter);
                    } else {
                        self.runElseActions(self.actionsAdapter);
                    }
                }
                if (cb) {
                    cb(err, result);
                }
            });
            if (!cb) {
                if (error) {
                    throw error;
                }
                return out;
            }
        }
    }

    matches(conditionsAdapter, cb) {
        var parser = new ExpressionParser();
        var expr = parser.parse(this.conditions);
        expr.postfix();
        expr.setVariables(conditionsAdapter);
        var result = expr.evaluate();
        if (result === false) {
            var e = "Syntax error";
            if (cb) {
                cb(e, result);
            }
        } else {
            if (cb) {
                cb(null, result === 'true');
            } else {
                return result === 'true';
            }
        }
    }

    runIfActions(actionsAdapter) {
        for (var i = 0; i < this.ifActions.length; i++) {
            var actionData = this.ifActions[i];
            var actionName = actionData.value;
            var actionFunction = actionsAdapter[actionName]
            if (actionFunction) {
                actionFunction(new Finder(actionData));
            }
        }
    }

    runElseActions(actionsAdapter) {
        for (var i = 0; i < this.elseActions.length; i++) {
            var actionData = this.elseActions[i];
            var actionName = actionData.value;
            var actionFunction = actionsAdapter[actionName]
            if (actionFunction) {
                actionFunction(new Finder(actionData));
            }
        }
    }

}
